import {
  Button,
  Heading,
  HStack,
  TabBar,
  VStack,
} from '@ayble-health/dashboard-components';
import { ArrowRightIcon } from 'lucide-react';

const { REACT_APP_HEALTHIE_URL } = process.env;

type Props = {
  memberId?: number;
  tabs: { label: string; count?: number }[];
  activeTab: number;
  setActiveTab: (i: number) => void;
};

export const AppointmentsColumnHeader = ({
  memberId,
  tabs,
  activeTab,
  setActiveTab,
}: Props) => {
  const handleManageCalendar = () => {
    if (memberId) {
      const healthieCalendarUrl = `${REACT_APP_HEALTHIE_URL}/providers/${memberId}/appointments`;

      window.open(healthieCalendarUrl, '_blank', 'noopener');
    }
  };

  return (
    <VStack
      px={8}
      pt={6}
      gap={2}
      borderBottomWidth={1}
      boxShadow="0px 4px 6px -2px rgba(0,0,0,0.1)"
    >
      <Heading size="sm" color={'ink'} mb={1}>
        Appointments
      </Heading>
      <HStack w={'100%'} justifyContent={'space-between'} alignItems={'center'}>
        <TabBar
          tabs={tabs}
          activeIndex={activeTab}
          setActiveIndex={setActiveTab}
          borderBottomWidth={0}
        />
        <Button
          onClick={handleManageCalendar}
          variant={'outline'}
          size={'sm'}
          borderRadius={'lg'}
          fontWeight={500}
          h={9}
        >
          Manage Calendar
          <ArrowRightIcon style={{ width: 16, height: 16 }} />
        </Button>
      </HStack>
    </VStack>
  );
};

export default AppointmentsColumnHeader;
